import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { ArchiveEstimateMutation as ArchiveEstimateMutationResult } from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const ArchiveEstimateMutation = graphql(`
  mutation ArchiveEstimate($id: ID!) {
    archiveEstimate(id: $id) {
      id
    }
  }
`);

const useArchiveEstimate = (args: {
  projectId: string;
  options?: UseMutationOptions<
    ArchiveEstimateMutationResult,
    Error,
    { id: string }
  >;
}) => {
  const { projectId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation({
    mutationFn: (variables: { id: string }) => {
      return gqlClient.request(ArchiveEstimateMutation, variables);
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.estimates(projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useArchiveEstimate;
